import api from './api';

export interface IndicadorPlano {
  id: string;
  planoTrabalhoId: string;
  unidade: string;
  quantidade: number;
  descricao?: string;
  dataCriacao?: string;
  dataAtualizacao?: string;
}

const indicadorPlanoService = {
  listByPlano: async (planoId: string): Promise<IndicadorPlano[]> => {
    const res = await api.get(`/indicador-plano/plano/${planoId}`);
    return res.data;
  },

  create: async (payload: Omit<IndicadorPlano, 'id' | 'dataCriacao' | 'dataAtualizacao'>): Promise<IndicadorPlano> => {
    const res = await api.post('/indicador-plano', payload);
    return res.data;
  },

  update: async (id: string, payload: Partial<IndicadorPlano>): Promise<IndicadorPlano> => {
    const res = await api.put(`/indicador-plano/${id}`, payload);
    return res.data;
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/indicador-plano/${id}`);
  },
};

export default indicadorPlanoService;